// ugly way of accessing the data - server returns either an object with array inside or just an empty array
export const formatCarList = (object) =>
  (object.data && object.data.valueList ? object.data.valueList : []).map((item) => ({
    value: item.value,
    label: item.value,
  }));
